import { Icon } from "../../icons";

interface SidebarCollapseProps {
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
}

/** The round tab on the sidebar's edge that collapses or expands it. */
export function SidebarCollapse({ collapsed, onCollapsedChange }: SidebarCollapseProps): React.JSX.Element {
  return (
    <button
      type="button"
      className={`nb-side-collapse${collapsed ? " is-collapsed" : ""}`}
      aria-label={collapsed ? "Expand menu" : "Collapse menu"}
      aria-expanded={!collapsed}
      onClick={() => onCollapsedChange(!collapsed)}
    >
      <Icon name="chevronLeft" />
    </button>
  );
}
